export const filterPillStyle = (theme, { isActive = false, hasSelection = false } = {}) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.5),
  height: 32,
  padding: hasSelection ? theme.spacing(0, 0.75, 0, 1.5) : theme.spacing(0, 1.25),
  borderRadius: "8px",
  border: `1px solid ${isActive ? "transparent" : theme.palette.system[400]}`,
  backgroundColor: isActive ? theme.palette.tertiary[300] : theme.palette.system[0],
  cursor: "pointer",
  "&:hover": {
    backgroundColor: isActive ? theme.palette.tertiary[300] : theme.palette.system[50]
  },
  "&:disabled": {
    cursor: "default",
    backgroundColor: theme.palette.grey[50],
    borderColor: theme.palette.grey[300]
  }
});
